// extracted by mini-css-extract-plugin
export default {"configGroup":"ScenarioItems_configGroup__aa44Q","configLabel":"ScenarioItems_configLabel__aoAPo","configItem":"ScenarioItems_configItem__WSlEz"};